'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Down = require('./Down');

var _Down2 = _interopRequireDefault(_Down);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Down: _Down2.default
};


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/icons/lib/components/Carets/index.js
// module id = 74
// module chunks = 0 1 2 3 4 5 6 7 8 9